import React from 'react';
import LazyLoad from 'react-lazyload';

export default ({ children }) => {
  return (
    <LazyLoad
      offset={300}
      height={300}
      once
      placeholder={
        <section id='in-page-lead'>
          <h2>Get matched with a financial advisor in four easy steps.</h2>
        </section>
      }>
      {children}
    </LazyLoad>
  );
};
